module.exports = __webpack_public_path__ + "assets/img/diaocha.8db87274.svg";